import { nonEmptyTrimmedStringFromUnknown } from "../protocol/shared.js";
import { clientMessageIdSchema } from "../protocol/client-message-id.js";
import { spaceDispatchTraceAttemptStatusSchema, spaceDispatchTraceDispatchStatusSchema } from "./space-dispatch-trace.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/space-dispatch-lookup.ts
const optionalSelectorSchema = z$1.preprocess((value) => {
	const normalized = String(value ?? "").trim();
	return normalized.length > 0 ? normalized : void 0;
}, z$1.string().min(1).optional());
const optionalClientMessageIdSchema = z$1.preprocess((value) => {
	const normalized = String(value ?? "").trim();
	return normalized.length > 0 ? normalized : void 0;
}, clientMessageIdSchema.optional());
const getSpaceDispatchLookupInputSchema = z$1.strictObject({
	spaceId: nonEmptyTrimmedStringFromUnknown,
	sourceSignalId: optionalSelectorSchema,
	clientMessageId: optionalClientMessageIdSchema,
	targetProfileId: optionalSelectorSchema
}).superRefine((value, context) => {
	if (Number(value.sourceSignalId !== void 0) + Number(value.clientMessageId !== void 0) === 1) return;
	context.addIssue({
		code: "custom",
		message: "exactly one of sourceSignalId or clientMessageId is required",
		path: ["sourceSignalId"]
	});
});
const spaceDispatchLookupMatchSchema = z$1.strictObject({
	dispatchId: z$1.string().trim().min(1),
	sourceSignalId: z$1.string().trim().min(1),
	targetProfileId: z$1.string().trim().min(1),
	status: spaceDispatchTraceDispatchStatusSchema,
	attemptCount: z$1.int().min(0),
	latestAttemptId: z$1.string().trim().min(1).nullable(),
	latestAttemptStatus: spaceDispatchTraceAttemptStatusSchema.nullable(),
	latestAttemptErrorCode: z$1.string().trim().min(1).nullable(),
	latestAttemptErrorMessage: z$1.string().trim().min(1).nullable()
});
const getSpaceDispatchLookupResponseSchema = z$1.strictObject({
	query: z$1.strictObject({
		spaceId: z$1.string().trim().min(1),
		sourceSignalId: z$1.string().trim().min(1).nullable(),
		clientMessageId: clientMessageIdSchema.nullable(),
		targetProfileId: z$1.string().trim().min(1).nullable()
	}),
	matches: z$1.array(spaceDispatchLookupMatchSchema)
});
//#endregion
export { getSpaceDispatchLookupInputSchema, getSpaceDispatchLookupResponseSchema, spaceDispatchLookupMatchSchema };

//# sourceMappingURL=space-dispatch-lookup.js.map